import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import HookSelectFormControl from '../HookSelectFormControl';

import ControlsDataService from 'services/ControlsDataService';

import useResources from 'hooks/useResources';

import { Country } from 'types/zod/controls-data';

export interface ISelectItem {
    value: any;
    title: string;
}

interface HookCountryFormControlProps {
    name: string;
    countriesToSkip?: string[];
    [key: string]: any;
}

const HookCountryFormControl = (props: HookCountryFormControlProps) => {
    const { countriesToSkip = [] } = props;

    const form = useFormContext();

    const [countries, setCountries] = useState<Country[]>([]);
    const { t } = useResources();

    useEffect(() => {
        (async () => {
            const controlsData = await ControlsDataService.get(['countries']);
            setCountries(controlsData?.countries ?? []);
        })();
    }, []);

    return (
        <HookSelectFormControl
            {..._.omit(props, 'countriesToSkip')}
            name={props.name}
            items={countries
                .filter((s) => !countriesToSkip.includes(s.code))
                .map((s) => ({ value: s.code, title: s.name }))}
            addEmptyItem={true}
            emptyItemTitle={t('ui.selectPlaceHolder.country')}
            onChange={(event: any) => {
                const newValue = event.target.value;
                form.setValue(props.name, newValue);
            }}
        />
    );
};

export default HookCountryFormControl;
